import React from "react";
import { Grid, Avatar } from "@pushpress/shared-components";
import { getCompleteName, getInitials } from "../../../utils/misc";

interface StaffCardProps {
  className?: string;
  staff: {
    firstName?: string;
    lastName?: string;
  };
}

function StaffCard(props: StaffCardProps) {
  const { staff, className } = props;
  const staffInitials = getInitials(staff?.firstName, staff?.lastName);
  const name = getCompleteName(staff?.firstName, staff?.lastName);
  return (
    <Grid container alignItems="center" className={className}>
      <Grid item>{<Avatar size="medium">{staffInitials}</Avatar>}</Grid>
      <Grid item>{name}</Grid>
    </Grid>
  );
}

export default StaffCard;
